import { render, staticRenderFns } from "./concact.vue?vue&type=template&id=63b5cdf5&scoped=true"
import script from "./concact.vue?vue&type=script&lang=js"
export * from "./concact.vue?vue&type=script&lang=js"
import style0 from "./concact.vue?vue&type=style&index=0&id=63b5cdf5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b5cdf5",
  null
  
)

export default component.exports